import React, { useMemo } from 'react';
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';
import { DateTime } from 'luxon';

import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';

import useApp from 'app/context/useApp';

const useStyles = makeStyles(theme => ({
    feedItem: {
        marginTop: theme.spacing(3)
    },
    marginLeft: {
        marginLeft: theme.spacing(1)
    },
    groupLink: {
        verticalAlign: 'inherit'
    },
    cardContentCollapsed: {
        paddingTop: 0,
        position: 'relative'
    },
}));

export default function FeedElectionItem(props) {

    const { app } = useApp();
    const theme = useTheme();
    const classes = useStyles();

    const { election } = props;

    const StyledAvatar = withStyles({
        root: {
            width: 27,
            height: 27,
            fontSize: 14
        },
        colorDefault: {
            backgroundColor: app.club.branding.primary_color,
            color: theme.palette.getContrastText(app.club.branding.primary_color),
        },
        img: {
            objectFit: "contain"
        }
    })(Avatar);

    const subHeader = (
        <div>
            <Typography variant='body2' color="textSecondary" display='inline'>
                Published to&nbsp;
                {(election.proposal_group_id && election.proposal_group_id > 0) ? (
                    <Tooltip title={"Viewable to " + election.proposal_group.title} aria-label={"Viewable to " + election.proposal_group.title}>
                        <Link
                            variant="subtitle2"
                            component="button"
                            className={classes.groupLink}
                            color="secondary"
                            >
                            {election.proposal_group.title}
                        </Link>
                    </Tooltip>
                ) : (
                    <Tooltip title="Viewable to everyone" aria-label="Viewable to everyone">
                        <Link
                            variant="subtitle2"
                            component="button"
                            className={classes.groupLink}
                            color="secondary"
                            >
                            {app.club.name}
                        </Link>
                    </Tooltip>
                )}
                &nbsp;{DateTime.fromISO(election.proposals_start_at).toRelative()}
            </Typography>
        </div>
    )

    return (
        <Card className={classes.feedItem}>
            <CardHeader
                avatar={
                    <StyledAvatar
                        src={app.club.branding.icon ? app.club.branding.icon.full_url : null}
                        alt={app.club.name}
                        variant="rounded"
                        >
                        {app.club.branding.acronym_short}
                    </StyledAvatar>
                }
                title={
                    <Typography variant='subtitle2' color="textPrimary">
                        {app.club.name}
                    </Typography>
                }
                subheader={subHeader}
            />
            <CardContent>
                <Typography variant="h6" color="textSecondary">
                    Ongoing Election: <Typography component="span" color="secondary" variant="inherit">{election.formatted_name}</Typography>
                </Typography>
                <Typography variant="subtitle1" color="textPrimary" gutterBottom>
                    {DateTime.fromISO(election.proposals_start_at).toLocaleString(DateTime.DATETIME_MED)} - {DateTime.fromISO(election.proposals_end_at).toLocaleString(DateTime.DATETIME_MED)}
                </Typography>
                <Typography
                    variant="body1"
                    component="p"
                    color="textSecondary"
                    dangerouslySetInnerHTML={{__html: election.description}}
                />

            </CardContent>
            <CardActions disableSpacing>
                <Grid container justify="space-between" alignItems="center">
                    <Grid item>
                        <Button
                            color="secondary"
                            component={RouterLink}
                            aria-label="View Event"
                            to={`/elections/${election.id}/proposal`}
                            >
                            Make a Proposal
                        </Button>
                    </Grid>
                    <Grid item>

                    </Grid>
                </Grid>
            </CardActions>
        </Card>
    )
}
